import AxiosController from '@/controllers/AxiosController'
export default class AuthController {
    static login(data) {
        return AxiosController.post('/auth/login', data)
    }

    static logout() {
        // AxiosService.setToken('')
    }

    static signup(data) {
        return AxiosController.post('/auth/signup', data)
    }

    static autoLogin(data) {
        return AxiosController.post('/auth/autoLogin', data)
    }
}
